import React, { useState } from 'react';
import toast from 'react-hot-toast';
import DialogComponent from '../dialog/dialog.component';
import {
  IMAGE_REPORT_REASONS,
  ProfileImageType,
  reportProfileImage,
} from '../../api/report/report-profile-image.api';

interface Props {
  visible: boolean;
  onClose: () => void;
  targetUserId: string;
  imageType: ProfileImageType;
}

const ReportImageDialog: React.FC<Props> = ({
  visible,
  onClose,
  targetUserId,
  imageType,
}) => {
  const [reason, setReason] = useState<number | null>(null);
  const [content, setContent] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (reason === null) {
      toast.error('Vui lòng chọn lý do');
      return;
    }
    try {
      setSubmitting(true);
      await reportProfileImage({ targetUserId, imageType, reason, content });
      toast.success('Đã gửi báo cáo. Cảm ơn bạn!');
      setReason(null);
      setContent('');
      onClose();
    } catch {
      toast.error('Không gửi được báo cáo, thử lại sau');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <DialogComponent
      visible={visible}
      onClose={onClose}
      title={`Báo cáo ${imageType === 'cover' ? 'ảnh bìa' : 'ảnh đại diện'}`}
      placement="CENTER"
    >
      <div className="flex w-full max-w-[440px] flex-col gap-4 p-6">
        <p className="text-sm text-slate-600 dark:text-slate-300">
          Chọn lý do báo cáo. Quản trị viên sẽ xem xét và xử lý.
        </p>
        <div className="flex flex-col gap-2">
          {IMAGE_REPORT_REASONS.map((r) => (
            <label
              key={r.value}
              className={`flex cursor-pointer items-center gap-3 rounded-lg border px-3 py-2.5 text-sm transition-colors ${
                reason === r.value
                  ? 'border-sky-500 bg-sky-50 dark:bg-sky-900/20'
                  : 'border-[#E5E7EB] hover:bg-slate-50 dark:border-slate-700 dark:hover:bg-slate-800'
              }`}
            >
              <input
                type="radio"
                name="report-reason"
                className="accent-sky-600"
                checked={reason === r.value}
                onChange={() => setReason(r.value)}
              />
              <span className="text-slate-700 dark:text-slate-200">{r.label}</span>
            </label>
          ))}
        </div>
        <textarea
          rows={2}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Mô tả thêm (không bắt buộc)…"
          className="ui-input w-full resize-none px-3 py-2 text-sm"
        />
        <div className="mt-1 flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-50 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700"
          >
            Huỷ
          </button>
          <button
            type="button"
            onClick={submit}
            disabled={submitting}
            className="rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700 disabled:opacity-50"
          >
            Gửi báo cáo
          </button>
        </div>
      </div>
    </DialogComponent>
  );
};

export default ReportImageDialog;
